import { BrandThemesEnum, ImageRatioEnum, PositionEnum, SizesEnum, ThemesEnum } from '@seb/web-design-system/core';
import { ArgumentsLayoutEnum } from '@seb/web-design-system/arguments';

import { WcConfig } from '../../models/wc-config.model';

export const wcRowentaConfig: WcConfig = {
  isRecipesEnabled: false,
  warranty: '/warranty',
  sliderCategoryOnly: true,
  isTeaserEmbedded: false,
  linkCardSubcategories: true,
  iconPos: PositionEnum.left,
  reinssurance: {
    textConfig: PositionEnum.center,
    hasSubline: false,
    theme: ThemesEnum.veryLight
  },
  isThemeDark: true,
  recipeDetailsPage: {
    reviews: {
      backgroundTheme: ThemesEnum.default,
      titleTheme: BrandThemesEnum.brand
    }
  },
  categoryPage: {
    lame1: {
      textConfig: PositionEnum.center,
      // mediaConfig: PositionEnum.right,
      theme: BrandThemesEnum.brandDark
      // backgroundTheme: ThemesEnum.default
    },
    lame4: {
      backgroundTheme: ThemesEnum.default,
      textConfig: PositionEnum.left
    },
    lame7: {
      // textConfig: PositionEnum.center,
      // mediaConfig: PositionEnum.left,
      // theme: ThemesEnum.light,
      // layout: ArgumentsLayoutEnum.default
    },
    faq: {
      backgroundTheme: ThemesEnum.default
    }
  },
  subCategoryPage: {
    lame1: {
      textConfig: PositionEnum.center,
      // mediaConfig: PositionEnum.right,
      theme: BrandThemesEnum.brandDark
      // layout: ArgumentsLayoutEnum.default,
      // backgroundTheme: ThemesEnum.default
    },
    lame4: {
      titleTextConfig: PositionEnum.left,
      titleTheme: ThemesEnum.light,
      pushSize: SizesEnum.xs,
      pushImageRatio: ImageRatioEnum.r4_3,
      pushTextConfig: PositionEnum.left,
      pushMediaConfig: PositionEnum.top,
      pushTheme: BrandThemesEnum.brand,
      backgroundTheme: BrandThemesEnum.brand
    },
    lame5: {
      titleTheme: ThemesEnum.dark,
      titleTextConfig: PositionEnum.left,
      backgroundTheme: ThemesEnum.default
    },
    lame7: {
      textConfig: PositionEnum.left,
      mediaConfig: PositionEnum.left,
      theme: BrandThemesEnum.brand,
      layout: ArgumentsLayoutEnum.divided,
      hasGradient: false
      // backgroundTheme: ThemesEnum.default
    },
    lame8: {
      textConfig: PositionEnum.left,
      theme: ThemesEnum.dark,
      mediaConfig: PositionEnum.right,
      layout: ArgumentsLayoutEnum.divided,
      hasGradient: false
    },
    lame9: {
      // titleTextConfig: PositionEnum.center,
      // titleTheme: BrandThemesEnum.brand,
      // backgroundTheme: ThemesEnum.default
    },
    lame10: {
      textConfig: PositionEnum.left,
      theme: ThemesEnum.promo2,
      // mediaConfig: PositionEnum.left,
      layout: ArgumentsLayoutEnum.default
    },
    lame11: {
      titleTextConfig: PositionEnum.left,
      titleTheme: ThemesEnum.dark,
      backgroundTheme: ThemesEnum.default
    }
  },
  pdp: {
    bundlesOrProducts: {
      backgroundTheme: ThemesEnum.white,
      titleTheme: ThemesEnum.dark,
      titleUnderlined: false
    },
    designedFor: {
      backgroundTheme: ThemesEnum.default,
      titleTheme: ThemesEnum.dark,
      titleUnderlined: false
    },
    productInfoArguments: {
      theme: BrandThemesEnum.brand,
      titleTheme: ThemesEnum.light,
      titleUnderlined: false
    },
    benefits: {
      backgroundTheme: BrandThemesEnum.brand,
      titleTheme: ThemesEnum.light,
      titleUnderlined: false
    },
    range: {
      backgroundTheme: ThemesEnum.default,
      titleTheme: ThemesEnum.dark,
      titleUnderlined: false
    },
    recipes: {
      backgroundTheme: ThemesEnum.default,
      titleTheme: ThemesEnum.dark,
      titleUnderlined: false
    },
    comparator: {
      backgroundTheme: ThemesEnum.white,
      titleTheme: ThemesEnum.dark,
      titleUnderlined: false
    },
    freeEditoBUArguments: {
      theme: BrandThemesEnum.brand,
      titleTheme: ThemesEnum.light,
      titleUnderlined: false
    },
    freeEditoLocalArguments: {
      theme: BrandThemesEnum.brand,
      titleTheme: ThemesEnum.light,
      titleUnderlined: false
    },
    howTo: {
      backgroundTheme: ThemesEnum.default,
      titleTheme: ThemesEnum.dark,
      titleUnderlined: false,
      pushTheme: ThemesEnum.light,
      pushTitleTheme: ThemesEnum.dark
    },
    accessories: {
      backgroundTheme: ThemesEnum.white,
      titleTheme: ThemesEnum.dark,
      titleUnderlined: false
    },
    replacementParts: {
      backgroundTheme: ThemesEnum.default,
      titleTheme: ThemesEnum.dark,
      titleUnderlined: false
    },
    ifu: {
      backgroundTheme: ThemesEnum.default,
      titleTheme: ThemesEnum.dark,
      titleUnderlined: false
    },
    faqs: {
      backgroundTheme: ThemesEnum.white,
      titleTheme: ThemesEnum.dark,
      titleUnderlined: false
    },
    disclaimer: {
      backgroundTheme: ThemesEnum.default
    }
  }
};
